import { render, staticRenderFns } from "./header-text.vue?vue&type=template&id=37012a5c&"
import script from "./header-text.vue?vue&type=script&lang=js&"
export * from "./header-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports